// Short explanations of every space, shown when a space is inspected (paraphrased from
// docs/unfathomable/rules-outline.md §4 and §6, not the printed reference card).
import * as uf from "../../../../common/unfathomable";

const kInterior: Partial<Record<uf.SpaceId, string>> = {
  bridge: "空间行动：冒险放置 1 名乘客，然后查看神话牌堆或航点牌堆顶 2 张，1 张放回顶部、1 张放到底部（供应区没有乘客时不能使用）。",
  chapel: "空间行动：二选一——仪式轨后退 1；或弃 1 张学识卡并掷骰，骰值 + 牌值 ≤ 6 则 -1 理智，然后仪式轨前进 1。",
  cabin: "空间行动：选一名角色进行检定 8（影响 + 观察），通过则把该角色送进禁闭室。",
  cargo: "空间行动：查看物品牌堆顶 2 张，1 张放到底部，另 1 张拿到面前。",
  galley: "空间行动：从任意非背叛牌堆共抽最多 5 张，然后掷骰，骰值 < 抽牌数则 -1 食物。",
  boiler: "空间行动：弃 1 张力量卡并掷骰，骰值 + 牌值 ≤ 6 则 -1 燃料，然后航迹前进 1。",
  sickbay: "被击败的人类会被送到这里；在这里获得技能时只能抽 1 张。可以正常移动离开，深潜者不会进入。",
  brig: "被关押的角色向检定最多加 1 张牌，空间能力受限。空间行动：检定 8（学识 + 力量），通过则移动到任意船上空间。",
};

export function spaceDescription(sp: uf.SpaceId): string {
  const info = uf.kSpaces[sp];
  const arrow = info.arrow ? uf.spaceName(info.arrow) : null;
  if (info.kind === "interior") {
    const dmg = uf.kDamageableSpaces.includes(sp as uf.InteriorSpaceId) ? "可能受损；受损时不能使用空间行动，深潜者会被吸引过来。" : "";
    return `${kInterior[sp] ?? ""}${dmg ? `\n${dmg}` : ""}`;
  }
  if (info.kind === "deck") {
    return `乘客会被冒险放置到甲板上，同一空间的角色可以用行动救援他们。深潜者从这里继续移向${arrow ?? "室内"}。`;
  }
  const front = uf.kFrontWater.includes(sp as uf.WaterSpaceId)
    ? `深渊里的怪物掷出 ${info.numbers[0]}–${info.numbers[info.numbers.length - 1]} 时会从这里浮出。` : "";
  const back = sp === "Wu7" || sp === "Wl8" ? "这里是最后方的水域，被甩向船尾的怪物会沉回深渊。" : "";
  return `只有怪物会出现在水域。航迹推进时，水域里的怪物会被甩向船尾一格。${back}${front}深潜者从这里登上${arrow ?? "甲板"}。`;
}
